import UnfinishedTaskRouter from '@/components/pages/unfinishedTask/index.vue';
import UnfinishedTasks from '@/components/pages/unfinishedTask/UnfinishedTasks.vue';
import UnfinishedTaskDetail from '@/components/pages/unfinishedTask/UnfinishedTaskDetail.vue';

export default {
  path: '/unfinishedTasks',
  name: 'UnfinishedTaskRouter',
  component: UnfinishedTaskRouter,
  children: [
    {
      path: '/unfinishedTasks',
      component: UnfinishedTasks,
      name: 'UnfinishedTasks',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/unfinishedTasks/:deadlineId',
      component: UnfinishedTaskDetail,
      name: 'UnfinishedTaskDetail',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
  ],
};
